import {keyframes} from 'stitches/config'

/* eslint-disable max-lines */
export const tableWrapper = {
    backgroundColor: '$tableBackground',
    border: '1px solid $tableBorder',
    borderRadius: '$tableBorder',
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%',
}

export const tableContent = {
    overflowX: 'auto',
    variants: {noScroll: {true: {overflowX: 'visible'}}},
}

export const tableHeader = {
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: '50px',
    padding: '$tableHeaderPaddingVertical $tablePaddingHorizontal',

}

export const tableFooter = {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'flex-start',
    padding: '$tableFooterPaddingVertical $tablePaddingHorizontal',
}

export const styledTable = {
    backgroundColor: '$tableBackground',
    borderColor: '$tableBorder',
    borderRadius: '$tableBorder',
    borderSpacing: 0,
    borderStyle: 'solid',
    borderWidth: 1,
    color: '$tableText',
    fontSize: '$table',
    variants: {
        tableComponent: {
            true: {
                borderLeftWidth: 0,
                borderRightWidth: 0,
            },
        },
        // eslint-disable-next-line sort-keys
        noHeader: {
            false: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
            },
            true: {
                '> thead > tr:first-child': {
                    '> th:first-child': {borderTopLeftRadius: '$tableBorder'},
                    '> th:last-child': {borderTopRightRadius: '$tableBorder'},
                },
                'borderTopWidth': 0,

            },
        },
        shouldRenderPagination: {
            false: {
                '> tbody > tr:last-child': {
                    '> td:first-child': {borderBottomLeftRadius: '$tableBorder'},
                    '> td:last-child': {borderBottomRightRadius: '$tableBorder'},
                },
                'borderBottomWidth': 0,
                'tr:last-child > td': {paddingBottom: '30px'},
            },
            true: {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
        },
        stickyFirstColumn: {
            true: {
                'tr > td:first-child, tr > th:first-child': {
                    borderRight: '1px solid $tableBorder',
                    left: '0px',
                    position: 'sticky',
                    top: 'auto',
                    zIndex: 1,
                },
            },
        },
        stickyLastColumn: {
            true: {
                'tr > td:last-child, tr > th:last-child': {
                    borderLeft: '1px solid $tableBorder',
                    position: 'sticky',
                    right: '0px',
                    top: 'auto',
                },
            },
        },
    },
    width: '100%',
}

export const styledTH = {
    backgroundColor: '$tableHeaderBackground',
    borderBottom: '1px solid $tableBorder',
    color: '$tableHeaderText',
    fontSize: '$tableHeader',
    fontWeight: '$tableHeader',
    padding: '$tableHeaderPaddingVertical $tableHeaderPaddingHorizontal',
    textAlign: 'left',
    whiteSpace: 'nowrap',
}

export const styledTR = {
    '&:nth-child(even)': {
        '> td, > th': {background: '$tableRowBackgroundEven'},
        'background': '$tableRowBackgroundEven',
    },
    // eslint-disable-next-line sort-keys
    '&:hover': {'> td, > th': {background: '$tableBackgroundHover'}},
    'variants': {
        noHover: {
            true: {
                '&& > th': {background: '$tableHeaderBackground'},
                // eslint-disable-next-line sort-keys
                '&& > td': {background: '$tableBackground'},
                '&&:nth-child(even)': {'> td, > th': {background: '$tableRowBackgroundEven'}},
            },

        },
        selected: {true: {'&& > td, && > th': {background: '$tableBackgroundHover'}}},
    },

}

export const styledTD = {
    '> div': {margin: 0},
    'backgroundColor': '$tableBackground',
    'padding': '$tablePaddingVertical $tablePaddingHorizontal',
    'variants': {
        additional: {
            true: {
                borderBottom: '1px solid $tableBorder',
                padding: 0,
            },
        },
    },
    'verticalAlign': 'top',
}

export const paginationWrapper = {
    '> div': {margin: 0},
    'display': 'flex',
    'flexGrow': 1,
    'justifyContent': 'flex-end',
}

export const pageSizeControl = {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
}

export const pageSizeLabel = {
    color: '$tableText',
    fontSize: '$table',
    variants: {capitalize: {true: {textTransform: 'capitalize'}}},
    whiteSpace: 'nowrap',
}

export const pageSizeSelectWrapper = {
    minWidth: '75px',
    width: '65px',
}

export const cellContent = {
    alignItems: 'center',
    display: 'flex',
    variants: {centered: {true: {justifyContent: 'center'}}},
}

export const checkboxAllWrapper = {
    '> div': {margin: 0},
    '> svg': {
        left: '50%',
        pointerEvents: 'none',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        width: 'calc(100% - 10px)',
    },
    'input + div': {margin: 0},
    'marginRight': '20px',
    'position': 'relative',

}

export const tableHeaderRight = {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
}

export const adjustmentsButton = {
    background: 'none',
    border: 'none',
    color: '$resultsTableTextLighter',
    lineHeight: 0,
    margin: 0,
    padding: 0,
}

export const sortButton = {
    '&:hover': {
        '> div > svg:first-child': {visibility: 'visible'},
        'cursor': 'pointer',
        'textDecoration': 'underline',
    },
    '> div': {
        lineHeight: 0,
        width: '14px',
    },
    '> div > svg': {visibility: 'hidden'},
    'alignItems': 'center',
    'background': 'none',
    'border': 'none',
    'color': '$tableHeaderText',
    'cursor': 'default',
    'display': 'flex',
    'fontSize': '$tableSortButton',
    'fontWeight': '500',
    'gap': '5px',
    'margin': 0,
    'padding': 0,
    'position': 'relative',
    // eslint-disable-next-line sort-keys
    'variants': {
        active: {
            true: {
                '> div > svg:first-child': {display: 'none'},
                '> div > svg:last-child': {visibility: 'visible'},
                'cursor': 'pointer',
            },
        },
        disabled: {
            true: {
                '&:hover': {
                    '> div > svg:first-child': {visibility: 'hidden'},
                    'cursor': 'default',
                    'textDecoration': 'none',
                },
            },
        },
        sort: {
            ASC: {'> div > svg:last-child': {transform: 'rotate(180deg)'}},
            DESC: {},
        },
    },
}

export const checkboxWrapper = {
    '> div': {margin: 0},
    'input + div': {margin: 0},
    'marginRight': '20px',
}

export const searchWrapper = {
    '> input': {
        border: 'none',
        fontSize: '$tableSearch',
        margin: 0,
        padding: '$tableSearchPaddingVertical $tableSearchPaddingHorizontal',
        width: '100%',
    },
    'alignItems': 'center',
    'display': 'flex',
    'flexGrow': '1',
    'padding': '$tableSearchPaddingVertical 0',
}

export const selectedRowsWrapper = {
    '& button': {
        marginLeft: '5px',
        padding: 0,
    },
    'alignItems': 'center',
    'background': '$tableHeaderRowsSelectedBackground',
    'borderRadius': '$tableSelectedBorder',
    'color': '$tableHeaderRowsSelected',
    'display': 'flex',
    'padding': '$tableHeaderRowsSelectedPaddingVertical $tableHeaderRowsSelectedPaddingHorizontal',
}

const animation1 = keyframes({
    from: {left: '-30px'},
    to: {left: '100%'},
})

export const cellLoader = {
    '&:after': {
        animation: `${animation1} 1s linear 0s infinite`,
        backgroundColor: '$tableLoaderSlider',
        bottom: 0,
        content: '',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '30px',
        zIndex: 10,
    },
    'backgroundColor': '$tableLoader',
    'borderRadius': '$tableLoader',
    'height': '16px',
    'maxWidth': '100px',
    'overflow': 'hidden',
    'position': 'relative',
    'width': '100%',
}

export const noResults = {
    display: 'flex',
    justifyContent: 'center',
}
